import React from "react";
import { useDispatch } from "react-redux";
import {
    openPharmacyOrderRejectModal,
    openPharmacyOrderAcceptModal,
    openPharmacyOrderGeneralAcceptModal
} from "../../../../../redux/actions/modals";
import SafeCallComponent from "../../lab-orders/LabOrderItem/children/SafeCallComponent";

const PharmacyVendorAssignedActionsMobile = (props) => {
    const dispatch = useDispatch();
    return (
        <>
            <div className="pharmacy-actions-buttons" style={{
                display:'flex',
                flexDirection:'row'
            }}>
                {/*<button
                    className="btn btn-small btn-success btn-accept margin-bottom-5"
                    onClick={() => {
                        dispatch(openPharmacyOrderAcceptModal(props, 'simple'));
                    }}
                >
                    <div className="title">
                        قبول نسخه به صورت عادی
                    </div>
                    <div className="sub-title">
                        (پیک یک طرفه بدون نیاز به نسخه)
                    </div>
                </button>
                <button
                    className="btn btn-small btn-success btn-accept margin-bottom-5"
                    onClick={() => {
                        dispatch(openPharmacyOrderAcceptModal(props,'insurance'));
                    }}
                >
                    <div className="title">
                        قبول نسخه تحت پوشش بیمه
                    </div>
                    <div className="sub-title">
                        (پیک رفت و برگشت اختیاری جهت دریافت اصل نسخه)
                    </div>
                </button>
                <button
                    className="btn btn-small btn-success btn-accept margin-bottom-5"
                    onClick={() => {
                        dispatch(openPharmacyOrderAcceptModal(props,'special'));
                    }}
                >
                    <div className="title">
                        قبول نسخه داروی خاص
                    </div>
                    <div className="sub-title">
                        (پیک رفت و برگشت الزامی جهت دریافت اصل نسخه)
                    </div>
                </button>*/}
                <button
                    className="btn btn-small btn-success btn-accept margin-bottom-5"
                    onClick={() => {
                        dispatch(openPharmacyOrderGeneralAcceptModal(props));
                    }}
                    style={{fontSize:'12px',width:'100%',margin:'3px'}}
                >
                    تایید سفارش
                </button>
                <button
                    className="btn btn-small btn-outline-dark btn-accept margin-bottom-5"
                    onClick={() => {
                        dispatch(openPharmacyOrderRejectModal(props));
                    }}
                    style={{fontSize:'12px',width:'100%',margin:'3px'}}
                >
                    رد سفارش
                </button>
            </div>
        </>
    );
};
export default PharmacyVendorAssignedActionsMobile;